import React from 'react'
import {Redirect, Route} from 'react-router-dom'
import {connect} from 'react-redux'

const PrivateRoute = ({ role, component: Component, ...rest }) => (
  <Route
    {...rest}
    render={(props) =>
      role ? (
        <Component {...props} />
      ) : (
        <Redirect
          to={{
            pathname: "/dashboard",
            state: { from: props.location },
          }}
        />
      )
    }
  />
);

const mapStateToProps = state => {
  return {
    role: state.login.role
  }
}

export default connect(mapStateToProps)(PrivateRoute)